import React from 'react';
var MultiToggle = function MultiToggle(_ref) {
  var setFilterChoiceState = _ref.setFilterChoiceState,
    items = _ref.items,
    filters = _ref.filters,
    filterName = _ref.filterName,
    label = _ref.label;
  var itemToggle = function itemToggle(e) {
    setFilterChoiceState(e.currentTarget.checked, e.currentTarget.value, filterName, false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll"
  }, Object.keys(items).map(function (facetLabel, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "g-checkbox__item",
      key: "".concat(facetLabel, "-checkbox-index")
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      type: "checkbox",
      onChange: itemToggle,
      id: "".concat(filterName, "-").concat(index),
      name: "".concat(filterName, "-").concat(index),
      checked: filters.includes(facetLabel),
      value: facetLabel,
      title: facetLabel
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: "".concat(filterName, "-").concat(index)
    }, facetLabel));
  })))));
};
export default MultiToggle;